export default __webpack_public_path__ + "static/media/LOGO-ilga.89270313.svg";